import { Link } from "@gromia/components/Link";
import * as s from "@gromia/components/theme/t.module.css";
import {
  pathToCategoryPage,
  pathToHomePage,
  pathToPostPage,
  WpCategoryT,
  WpPostT,
} from "@gromia/utils/models/blog";
import cx from "classnames";
import * as A from "fp-ts/lib/Array";
import { pipe } from "fp-ts/lib/function";
import * as NEA from "fp-ts/lib/NonEmptyArray";
import * as O from "fp-ts/lib/Option";
import React from "react";

type N = { to: string; label: NonNullable<React.ReactNode> };

export function Breadcrumbs(props: {
  category: O.Option<WpCategoryT>;
  post: O.Option<WpPostT>;
  raw?: O.Option<N>;
  raw2?: O.Option<N>;
  linkClass?: string;
}) {
  const head: N = { to: pathToHomePage(), label: "Home" };

  const tail: Array<O.Option<N>> = [
    pipe(
      props.category,
      O.map(c => ({ to: pathToCategoryPage(c), label: c.name })),
    ),
    pipe(
      props.post,
      O.map(p => ({ to: pathToPostPage(p), label: p.title })),
    ),
    props.raw ? props.raw : O.none,
    props.raw2 ? props.raw2 : O.none,
  ];

  const parts = pipe(tail, A.compact, x => A.cons(head, x));

  const sep = (n: number) => <span key={n.toString()}>|</span>;

  const init = pipe(
    parts,
    A.init,
    O.getOrElse<N[]>(() => []),
  );

  const last = pipe(parts, NEA.last);

  return (
    <div className={cx(s.fontSizeSmall2)}>
      {init.map((p, idx) => (
        <React.Fragment key={idx}>
          <Link
            className={cx(props.linkClass ? props.linkClass : s.textBody)}
            to={p.to}
          >
            {p.label}
          </Link>
          {sep(idx)}
        </React.Fragment>
      ))}
      <span className={cx(s.fontWeightBold)}>{last.label}</span>
    </div>
  );
}
